<amplify-authenticator [hideSignUp]="true">
</amplify-authenticator>